import { gql } from '@apollo/client';

export default gql`
  mutation deleteSection($_id: String) {
    deleteSection(_id: $_id) {
      ok
      message
      error
    }
  }
`;
